import React from "react";
import { User, Users, Baby } from "lucide-react";
import { FormTabType, Person } from "../types";

interface TabNavigationProps {
  activeTab: FormTabType;
  onChangeTab: (tab: FormTabType) => void;
  availableTabs?: FormTabType[];
  tabLabels?: {
    PERSONAL: string;
    COUPLE: string;
    CHILD: string | null;
  };
  person?: Person;
  excludeTabs?: FormTabType[];
}

const defaultTabLabels = {
  PERSONAL: "Pessoa",
  COUPLE: "Cônjuge",
  CHILD: "Filhos"
};

const tabIcons = {
  PERSONAL: () => <User className="w-4 h-4" />,
  COUPLE: () => <Users className="w-4 h-4" />,
  CHILD: () => <Baby className="w-4 h-4" />
};

const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  onChangeTab,
  availableTabs = ["PERSONAL", "COUPLE", "CHILD"],
  tabLabels = defaultTabLabels,
  person,
  excludeTabs = []
}) => {
  // Filtrar abas excluídas
  const tabs = availableTabs.filter(tab => !excludeTabs.includes(tab));

  // Condição adicional: só exibir CHILD se PERSONAL estiver preenchido
  // Cônjuge tem regra especial: exibir quando PERSONAL estiver preenchido,
  // mas não exigir que todos os campos do cônjuge estejam preenchidos
  const isPersonValid = !!(person?.name && person.email && person.cpf && person.celphone);
  
  // Contar filhos
  const childCount = person?.children?.length || 0;
  
  return (
    <div className="flex justify-center items-center gap-4 w-full">
      {tabs.map((tab) => {
        // Só desabilitar CHILD, COUPLE pode ser acessada desde que a pessoa principal esteja preenchida
        const isDisabled = tab === "CHILD" && !isPersonValid;
        
        return (
          <div
            key={tab}
            onClick={() => !isDisabled && onChangeTab(tab)}
            className={`flex flex-col justify-between items-center w-full h-[49px] ${isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
          >
            <div className="flex items-center justify-center w-full h-[35px] rounded-md bg-background/10">
              <span className="flex gap-2 items-center text-background text-xs sm:text-base font-medium">
                <span className="hidden sm:block">{tabIcons[tab]()}</span> 
                {tabLabels[tab]} 
                {tab === "CHILD" && childCount > 0 && 
                  `(${childCount.toString().padStart(2, '0')})`}
              </span>
            </div>
            {tab === activeTab && (
              <span className="w-full h-[5px] rounded-xs bg-primary" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default TabNavigation; 